/* ========================================
   MONTIS PICKLEBALL — SCROLL REVEAL
   ======================================== */
(function() {
  'use strict';

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  });

  function init() {
    const reveals = document.querySelectorAll('.montis-reveal, .montis-reveal-left, .montis-reveal-right, .montis-stagger');
    reveals.forEach(el => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
